import React, { memo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { icons, layouts, buttons } from 'seal-ui-components';
import { useLocation } from 'react-router-dom';
import { HeaderMenuToggle } from '@Actions/navigationActions';
import { NavTitle, TopNavContainer } from './TopNav.style';
import TopNavList from './components/TopNavList';

const TopNav = memo(() => {
    const dispatch = useDispatch();
    const location = useLocation();

    const isAuthenticated = useSelector(state => state.auth.isAuthenticated);
    const isSignedIn = useSelector(state => state.auth.isSignedIn);

    const { run: runningDocAnimation } = useSelector(state => state.documentAnimation);

    const { isHeaderMenuOpened } = useSelector(state => state.headerNavigation);

    const tabName = location.pathname.split('/')[1];
    const headerTitle = tabName === 'loading' ? 'Analyzer' : tabName;

    return (
        <layouts.HorizontalBox>
            <TopNavContainer isAuth={isAuthenticated || isSignedIn}>
                {isAuthenticated || isSignedIn ? (
                    <>
                        <TopNavList />
                        <buttons.InsetIconButton
                            size="large"
                            icon={<icons.MenuLargeIcon />}
                            disabled={runningDocAnimation}
                            onClick={() => dispatch(HeaderMenuToggle(!isHeaderMenuOpened))}
                            data-testid="toggle_menu_button"
                        />
                        <NavTitle data-testid="header_label">{headerTitle}</NavTitle>
                    </>
                ) : (
                    <NavTitle data-testid="header_label">Login</NavTitle>
                )}
            </TopNavContainer>
        </layouts.HorizontalBox>
    );
});

export default TopNav;
